/**
 * Local Storage Keys
 */
export const STORAGE_KEYS = {
  SENSOR_CONFIG: 'aqua_sensor_config',
  NOTIFICATION_CONFIG: 'aqua_notification_config',
  THEME: 'aqua_theme',
};

/**
 * Default Sensor Thresholds Configuration
 */
export const DEFAULT_THRESHOLDS = {
  temperature: { min: 15, idealMin: 20, idealMax: 28, max: 35 },
  oxygen: { min: 4, idealMin: 6, idealMax: 9, max: 12 },
  saturation: { min: 60, idealMin: 80, idealMax: 100, max: 120 },
};

export const DEFAULT_NOTIFICATION_TIMINGS = {
  temperature: 60,
  oxygen: 60,
  saturation: 60,
};

export const DEFAULT_NOTIFICATION_LEVELS = {
  warning: true,
  critical: true,
};

/**
 * Refresh interval options (in seconds)
 */
export const REFRESH_INTERVALS = [
  { value: 1, label: '1 segundo' },
  { value: 2, label: '2 segundos' },
  { value: 5, label: '5 segundos' },
  { value: 10, label: '10 segundos' },
  { value: 30, label: '30 segundos' },
  { value: 60, label: '1 minuto' },
];

/**
 * History limit for chart data
 */
export const HISTORY_LIMIT = 50;
